/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs'; 
import { AdvanceMasterApi } from '../api/advancemaster.api';
import { switchMap, map } from 'rxjs/operators';
import { AdvanceMasterData, AdvanceMaster } from '../../../interfaces/masters/advancemaster';

@Injectable()
export class AdvanceMasterService extends AdvanceMasterData {

  constructor(private api: AdvanceMasterApi) {
    super();
  }


  list(url: string): Observable<AdvanceMaster[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<AdvanceMaster>{
      return this.api.getById(url);
  }

  create(url: string, data:AdvanceMaster): Observable<AdvanceMaster[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:AdvanceMaster): Observable<AdvanceMaster> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url); 
  }
}
